import { formatUsd } from "../formatUsd.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** No quoted build fee until a per-tenant amount is supplied. */
export const DEFAULT_BUILD_FEE_CENTS = 0;
/**
 * BuildFeeViewModel issues the one-off build-fee invoice via the bridge and
 * exposes the returned hosted invoice URL. Empty or zero amount means this
 * tenant has no quote — the view hides pay, and create() does not invoice.
 */
export class BuildFeeViewModel extends ViewModel {
    client;
    description;
    constructor(client, amountCents = 0, description = "Lumora website build fee") {
        super({
            loading: false,
            error: null,
            invoiceUrl: null,
            status: null,
            amountCents: amountCents > 0 ? amountCents : 0,
        });
        this.client = client;
        this.description = description;
    }
    get amountCents() {
        return this.state.amountCents;
    }
    /** True only when this tenant has a positive stored quote. */
    get owed() {
        return this.amountCents > 0;
    }
    get hasQuotedFee() {
        return this.amountCents > 0;
    }
    get formattedAmount() {
        return formatUsd(this.amountCents);
    }
    /** Loads the signed-in tenant's quote. Missing or zero clears any amount. */
    async load() {
        await this.run(async () => {
            const status = await this.client.getBillingStatus();
            const cents = status.buildQuoteCents ?? 0;
            this.setState({ amountCents: cents > 0 ? cents : 0 });
        }, "Failed to load build fee.");
    }
    async create() {
        if (!this.hasQuotedFee) {
            return;
        }
        await this.run(async () => {
            const result = await this.client.createInvoice({
                amountCents: this.amountCents,
                description: this.description,
            });
            this.setState({
                invoiceUrl: result.hostedInvoiceUrl,
                status: result.status,
            });
        }, "Failed to create invoice.");
    }
}
//# sourceMappingURL=BuildFeeViewModel.js.map